import { useFormContext } from '@slal/ui/react-hook-form/core';
import { useEffect, useState } from 'react';

export const useInvestmentFundsCardData = () => {
    const { watch, control, trigger, setValue } = useFormContext();
    const [totalAllocation, setTotalAllocation] = useState(100);
    const [isInteracted, setIsInteracted] = useState(false);
    const [allocationTouched, setAllocationTouched] = useState({
        fund1: false,
        fund2: false,
        fund3: false,
        fund4: false,
        fund5: false,
    });

    const [
        clientName,
        productName,
        drawdown,
        drawdownType,
        drawdownAmount,
        drawdownPercent,
        contributions,
        contributionsAmount,
    ] = watch([
        'clientName',
        'productName',
        'drawdown',
        'drawdownType',
        'drawdownAmount',
        'drawdownPercent',
        'contributions',
        'contributionsAmount',
    ]);

    const allocationFields = watch(['fund1', 'fund2', 'fund3', 'fund4', 'fund5']);

    const investmentFundsCardDisabled =
        !clientName ||
        !productName ||
        (productName === 'postRetirement'
            ? drawdown === undefined ||
              (drawdown === 'Yes' &&
                  (drawdownType === 'percent'
                      ? drawdownPercent === undefined || drawdownPercent > 100
                      : drawdownAmount === undefined || drawdownAmount === 0))
            : contributions === undefined ||
              (contributions === 'Yes' && (contributionsAmount === undefined || contributionsAmount === 0)));

    const isTotalAllocationOverLimit = totalAllocation < 0;
    const isTotalAllocationInvalid = totalAllocation !== 0;

    const hasTouchedAllocationFields = Object.values(allocationTouched).some(touched => touched);

    const handleFieldBlur = (field: string) => {
        setAllocationTouched(prev => ({ ...prev, [field]: true }));
        setIsInteracted(true);
    };

    const handleBlurValidation = () => {
        setIsInteracted(true);
        if (isTotalAllocationInvalid) {
            trigger(['fund1', 'fund2', 'fund3', 'fund4', 'fund5']);
        }
    };

    useEffect(() => {
        const allocationValues = allocationFields.map(field => parseFloat(field) || 0);
        const totalUsed = allocationValues.reduce((sum, val) => sum + val, 0);
        setTotalAllocation(100 - totalUsed);
    }, [allocationFields]);

    return {
        watch,
        control,
        setValue,
        totalAllocation,
        isInteracted,
        isTotalAllocationOverLimit,
        isTotalAllocationInvalid,
        handleFieldBlur,
        handleBlurValidation,
        hasTouchedAllocationFields,
        investmentFundsCardDisabled,
    };
};
